import React, {
    useEffect,
    useState,
    useRef,
    useMemo
} from 'react';

import {
    LoadingStatus,
    useSetInstanceLoadingStatus,
    useGetInstanceLoadingStatus
} from '../../../../hooks/loadingStatusHooks.js';

import {
    useVerifySearch
} from '../../hooks/useVerifySearch.js';

import useListeningCurationFilterValues from '../../hooks/useListeningCurationFilterValues.js';


const DEBOUNCE_TIME_MS = 1500;

// This component is intended to delay rendering of `children` if either of the 'searchTermsAnd', 'searchTermsNot' props change. If it detects a change in those props,
// it'll immediately not render children (so that they never get a chance to render with the new version of the props) and then call debouncedSetter. When the function
// in debouncedSetter runs, it'll render the children which will see the new props and render with them.
export default function DelayedWidgetLoad({instanceId, showLoadingView, className, children}) {
    const listeningProps = useListeningCurationFilterValues().listening;
    const [showWidget, setShowWidget] = useState(true);

    const {orderedErrors} = useVerifySearch(true);
    const hasValidationError = _.find(orderedErrors, {
        isFatal: true
    });

    const debouncedShow = useRef(_.debounce(() => {
        setShowWidget(true);
    }, DEBOUNCE_TIME_MS));
    const newSearchProps = _.pick(listeningProps, ['searchTermsAnd', 'searchTermsNot']);

    const [lastSearchProps, setLastSearchProps] = useState(newSearchProps);
    const propsChanged = !_.isEqual(newSearchProps, lastSearchProps);

    const widgetLoadStatus = useGetInstanceLoadingStatus(instanceId);
    const statusUpdater = useSetInstanceLoadingStatus(instanceId);

    useEffect(() => {
        if (propsChanged && showWidget) {
            setShowWidget(false);
            debouncedShow.current();

            if (widgetLoadStatus !== LoadingStatus.LOADING) {
                statusUpdater(LoadingStatus.LOADING);
            }
        }

        if (propsChanged) {
            setLastSearchProps(newSearchProps);
        }
    }, [instanceId, newSearchProps, propsChanged, showWidget, statusUpdater, widgetLoadStatus]);

    const childWithInstanceIdProp = useMemo(() => {
        return React.cloneElement(
            children,
            {
                instanceId: instanceId
            }
        );
    }, [children, instanceId]);

    const renderWidget = !propsChanged && showWidget && !hasValidationError;
    const showLoading = showLoadingView && (!renderWidget || widgetLoadStatus === LoadingStatus.LOADING) && !hasValidationError;
    return (
        <>
            {showLoading &&
                <div className='tlw-flex tlw-h-full tlw-min-h-[158px] tlw-grow tlw-items-center tlw-justify-center tlw-text-[36px] tlw-text-gray-500'>
                    <span className='fa fa-circle-o-notch fa-spin'></span>
                </div>
            }

            <div
                className={`${className || ''} ${widgetLoadStatus === LoadingStatus.COMPLETE ? '' : 'tlw-hidden'}`}
            >
                {renderWidget && childWithInstanceIdProp}
            </div>
        </>

    );
}
